// Path: src/app/features/notas-fiscais/components/modal-historico-sefaz/modal-historico-sefaz.component.ts

import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

import { LogConsumoSefazService } from '../../../../shared/services/apis/dfe/log-consumo-sefaz.service';
import { PedidoBuscaSefazService } from '../../../../shared/services/apis/dfe/pedido-busca-sefaz.service';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { LogConsumoServicoSefazStruct } from '../../../../shared/services/structs/dfe/log-consumo-servico-sefaz.struct';
import { LogConsumoSefazListarRequest } from '../../../../shared/services/requests/dfe/log-consumo-sefaz-listar.request';
import { PedidoBuscaSefazRequest } from '../../../../shared/services/requests/dfe/pedido-busca-sefaz.request';
import { EmptyListComponent } from '../../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Empresa } from '../../../../shared/services/models/usuario/empresa.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ControleAcessoSefazStruct } from '../../../../shared/services/structs/dfe/controle-acesso-sefaz.struct';
import { ModeloDocumento } from '../../../../shared/services/models/dfe/modelo-documento.model';
import { SelectPesquisavelComponent } from '../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { ModeloDocumentoEnum } from '../../../../shared/enums/dfe/modelo-documento.enum';
import { OrigemConsultaDistribuicaoSefazDescricao } from '../../../../shared/enums/dfe/origem-consulta-distribuicao-sefaz.enum';
import { ConfirmModalComponent } from '../../../../shared/components/confirm-modal/confirm-modal.component';

export interface ModalHistoricoSefazData {
  listaEmpresas: Empresa[];
  idEmpresaLogada: number;
  controleAcessoSefazNFe: ControleAcessoSefazStruct | null;
  listaModeloDocumento: ModeloDocumento[];
}

@Component({
  selector: 'app-modal-historico-sefaz',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatTableModule,
    EmptyListComponent,
    LoadingBoxDefaultListComponent,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,   
    MatFormFieldModule,
    SelectPesquisavelComponent
  ],
  templateUrl: './modal-historico-sefaz.component.html',
  styleUrls: ['./modal-historico-sefaz.component.css']
})
export class ModalHistoricoSefazComponent implements OnInit {

  public logs: LogConsumoServicoSefazStruct[] = [];
  public isLoadingLogs = true;
  public isLoadingPedido = false;
  public isLoadingMais = false;

  public botaoBuscaDesabilitado = false;
  public tooltipMensagem = '';
  public listIdEmpresa: number[] = [];
  public isReiniciarNsu: boolean = false;
  public listaEmpresas: Empresa[] = [];
  public empresaSelectControl: FormControl;
  // Vazio = todos os modelos, como no filtro avançado do painel.
  public modeloDocumentoControl = new FormControl<number[]>([], { nonNullable: true });
  public listaModeloDocumento: ModeloDocumento[] = [];
  public controleAcessoSefazNFe: ControleAcessoSefazStruct | null = null;
  private paginaAtual = 0;
  public ultimaPagina = false;
  public dataSource = new MatTableDataSource<LogConsumoServicoSefazStruct>();
  private readonly MENSAGEM_656: string = 'Consumo Indevido. A Sefaz bloqueou a busca por 1 hora, pois outro sistema já está consultando este CNPJ. Verifique se há outro software realizando buscas automáticas.';

  public displayedColumns: string[] = ['dataHora', 'modelo', 'origem', 'codigo', 'mensagem', 'qtdDocs', 'nsuConsultado'];

  constructor(
    public dialogRef: MatDialogRef<ModalHistoricoSefazComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalHistoricoSefazData,
    private logSefazService: LogConsumoSefazService,
    private pedidoBuscaService: PedidoBuscaSefazService,
    private alertService: AlertService,
    private dialog: MatDialog,
  ) {
    this.listaEmpresas = data.listaEmpresas || [];
    this.empresaSelectControl = new FormControl(data.idEmpresaLogada);
    this.controleAcessoSefazNFe = data.controleAcessoSefazNFe || null;
    this.listaModeloDocumento = data.listaModeloDocumento || [];
  }

  ngOnInit(): void {
    this.empresaSelectControl.valueChanges.subscribe(() => {
        this.verificarRegraBotao();
        this.carregarLogs(true); 
    });
    this.modeloDocumentoControl.valueChanges.subscribe(() => this.carregarLogs(true));
    
    this.verificarRegraBotao();
    this.carregarLogs(true);
  }

  public carregarLogs(novaBusca: boolean): void {
    if (novaBusca) {
      this.paginaAtual = 0;
      this.logs = [];
      this.ultimaPagina = false;
      this.isLoadingLogs = true;
    } else {
      if (this.isLoadingMais || this.ultimaPagina) return; 
      this.paginaAtual++;
      this.isLoadingMais = true;
    }

    const idEmpresaSelecionada = this.empresaSelectControl.value;
    if (!idEmpresaSelecionada) {
      this.alertService.show('Aviso', 'Nenhuma empresa selecionada.', AlertType.warning);
      this.limparLoadings();
      return;
    }

    const request: LogConsumoSefazListarRequest = {
      listIdEmpresa: [idEmpresaSelecionada],
      listIdModeloDocumento: this.modeloDocumentoControl.value
    };
    this.logSefazService.getAll(request, this.paginaAtual).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          this.limparLoadings();
          return;
        }
        
        const logsMapeados = response.logs.map(log => {
            if (log.codigoRetornoSefaz === 656) {
                log.mensagemRetornoSefaz = this.MENSAGEM_656;
            }
            return log;
        });
        this.logs.push(...logsMapeados);
        this.dataSource.data = this.logs;
        this.ultimaPagina = this.logs.length >= response.totalRecords;
        this.verificarRegraBotao();
        this.limparLoadings();
      },
      error: (err) => {
        this.alertService.show('Erro inesperado', err.message, AlertType.error);
        this.limparLoadings();
      }
    });
  }

  public proximaPagina(): void {
    this.carregarLogs(false);
  }

  private limparLoadings(): void {
    this.isLoadingLogs = false;
    this.isLoadingMais = false;
  }

  private verificarRegraBotao(): void {
    const idSelecionado = this.empresaSelectControl.value;
    const empresaSelecionada = this.listaEmpresas.find(e => e.idEmpresa === idSelecionado);

    if (!empresaSelecionada?.certificadoValido) {
      this.botaoBuscaDesabilitado = true;
      this.tooltipMensagem = 'A busca na Sefaz está desabilitada, pois esta empresa está sem um certificado A1 válido.';
      return;
    }

    // A API decide se a busca está liberada (bloqueio da Sefaz e intervalo de 1 hora); as datas já vêm na hora da empresa.
    if (this.controleAcessoSefazNFe && !this.controleAcessoSefazNFe.isBuscaManualLiberada) {
      this.botaoBuscaDesabilitado = true;
      const datePipe = new DatePipe('pt-BR');
      const ultimaBusca = datePipe.transform(this.controleAcessoSefazNFe.datetimeUltimoAcesso, 'dd/MM/yyyy HH:mm');
      const liberacao = datePipe.transform(this.controleAcessoSefazNFe.datetimeLiberacaoBuscaManual, 'dd/MM/yyyy HH:mm');
      this.tooltipMensagem = 'Restrição da Sefaz: A busca manual só pode ser feita 1 vez por hora e nunca durante um bloqueio da Sefaz.'
        + (ultimaBusca ? ` Última busca: ${ultimaBusca}.` : '')
        + ` Liberada a partir de ${liberacao}.`;
      return;
    }

    this.botaoBuscaDesabilitado = false;
    this.tooltipMensagem = 'Solicitar nova busca de notas na Sefaz a partir do último nsu registrado.';
  }

  public solicitarBuscaManual(): void {
    const titulo = 'Confirmar Busca Manual na SEFAZ';
    let mensagemHtml: string;

    if (this.isReiniciarNsu) {
        mensagemHtml = `
            <p><strong>Atenção: Você marcou a opção "Buscar documentos do incío".</strong></p>
            <p>Ao confirmar, a busca será feita a partir do incício, buscando todos os documentos dos <strong>últimos 3 meses</strong> emitidos para esta empresa.</p>
            <p>Esta operação pode demorar e só deve ser usada em casos específicos.</p>
            <p>Por regra da Sefaz, a busca de documentos só pode ser realizada (no máximo) uma vez por hora.</p>
            <br>
            <p>Deseja prosseguir?</p>
        `;
    } else {
        mensagemHtml = `
            <p>Ao confirmar, será registrado um novo pedido de busca na SEFAZ a partir do <strong>último documento registrado</strong>.</p>
            <p>Por regra da Sefaz, a busca de documentos só pode ser realizada (no máximo) uma vez por hora.</p>
            <br>
            <p>Deseja prosseguir?</p>
        `;
    }

    const dialogRef = this.dialog.open(ConfirmModalComponent, {
        data: {
            title: titulo,
            innerHtml: mensagemHtml,
            buttonConfirm: 'Confirmar',
            buttonClose: 'Cancelar',
        },
    });

    dialogRef.afterClosed().subscribe({
        next: result => {
            if (!result || !result.confirm) {
                return;
            }

            if (this.isLoadingPedido) return;
            this.isLoadingPedido = true;
    
            const request: PedidoBuscaSefazRequest = {
              idEmpresaAlvo: this.empresaSelectControl.value,
              idModeloDocumento: 1,
              isReiniciarNsu: this.isReiniciarNsu 
            };
    
            this.pedidoBuscaService.criar(request).subscribe({
              next: (response) => {
                this.isLoadingPedido = false;
                if (response.isError) {
                  this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
                  return;
                }
        
                this.alertService.show('Sucesso!', 'O seu pedido de busca na SEFAZ foi criado com sucesso! O processamento ocorrerá dentro de alguns minutos.', AlertType.success);
                
                this.carregarLogs(true);
                this.isReiniciarNsu = false;
              },
              error: (err) => {
                this.isLoadingPedido = false;
                this.alertService.show('Erro inesperado', err.message, AlertType.error);
              }
            });
        }
    });
  }

  public obterDescricaoModelo(log: LogConsumoServicoSefazStruct): string {
    return log.idModeloDocumento === ModeloDocumentoEnum.CTe ? 'CT-e' : 'NF-e';
  }

  public obterDescricaoOrigem(log: LogConsumoServicoSefazStruct): string {
    return log.idOrigemConsultaDistribuicaoSefaz
      ? OrigemConsultaDistribuicaoSefazDescricao[log.idOrigemConsultaDistribuicaoSefaz]
      : '—';
  }

  public getSelectedEmpresaName(): string {
    const idSelecionado = this.empresaSelectControl.value;
    if (!idSelecionado) {
      return '';
    }
    const empresa = this.listaEmpresas.find(e => e.idEmpresa === idSelecionado);
    return empresa ? empresa.nomeEmpresa : '';
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
